import actionTypes from './action-types';
import actions from './actions';
import reducer from './reducer';
import middleware from './middleware';
export default {
  actionTypes,
  actions,
  middleware,
  reducer
};